import React from 'react';
import {
  Alert,
  Box,
  Button,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';
import { Player } from '../../api';
import { ButtonLink } from '../common/ButtonLink';
import { Link } from '../common/Link';
import styles from './styles.module.css';

export interface GameNotStartedProps {
  players: Player[];
  onStartGame?: () => void;
}

export const GameNotStarted: React.FC<GameNotStartedProps> = ({
  players,
  onStartGame,
}) => {
  if (players.length === 0) {
    return (
      <Alert
        action={
          <ButtonLink href="/gc/players" variant="primary">
            Add players
          </ButtonLink>
        }
      >
        <Box color="inherit">There are not players yet defined.</Box>
        <Box color="inherit">
          Please visit players page to add more players.
        </Box>
      </Alert>
    );
  }
  let playerLis = players.map((p) => <li key={p.name}>{p.name}</li>);
  return (
    <>
      <TextContent>
        <p>Players that are participating:</p>
        <ul>{playerLis}</ul>
      </TextContent>
      <Box padding={{ top: 's' }}>
        <SpaceBetween
          direction="horizontal"
          size="xs"
          className={styles['align-items-center']}
        >
          <Button variant="primary" onClick={() => onStartGame?.()}>
            Start Game
          </Button>
          <Box>or</Box>
          <Box>
            <Link href="/gc/players">change players</Link>
          </Box>
        </SpaceBetween>
      </Box>
    </>
  );
};
